import { colors } from '../../colors';
var input = {
  textColor: colors.metal
};
export default input;